import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-success",
  templateUrl: "./success.component.html",
  styleUrls: ["./success.component.css"],
  standalone: false,
})
export class SuccessComponent implements OnInit {
  amount: string;
  status: string;
  callbackUrl: string;
  isCallBackUrl: boolean;
  grouped: string;
  currency;

  message: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.amount = route.snapshot.params["amount"];
    this.status = route.snapshot.params["status"];
    this.message = atob(route.snapshot.params["callback"]);
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let res = atob(params.callback);

      const hasVisitedStatus = sessionStorage.getItem("hasVisitedStatus");

      if (res === "Invalid") {
        this.isCallBackUrl = false;
        this.message = "Invalid payment reference";
        // Don't navigate to /rating for invalid payments
        return;
      }

      if (res === "Payment already completed") {
        this.isCallBackUrl = false;
        this.message = res;
        return;
      }

      // Valid callback URL
      this.isCallBackUrl = true;
      this.callbackUrl = res;
      this.message = res;

      setTimeout(() => {
        this.redirectUser();
      }, 3000);

      // Only redirect to /rating for valid successful payments
      if (!hasVisitedStatus) {
        setTimeout(() => {
          sessionStorage.setItem("hasVisitedStatus", "true");
          this.router.navigate(["/rating"]);
        }, 6000);
      }
    });

    if (JSON.parse(sessionStorage.getItem("paymentDetails"))) {
      this.currency =
        JSON.parse(sessionStorage.getItem("paymentDetails"))["currency"] ||
        "NGN";
      sessionStorage.removeItem("paymentDetails");
    }
  }

  checkCallBack() {
    if (
      this.callbackUrl === "empty" ||
      this.callbackUrl === "undefined" ||
      this.callbackUrl === "Payment already completed"
    ) {
      this.isCallBackUrl = false;
      this.message = this.callbackUrl;
      return;
    } else {
      this.isCallBackUrl = true;

      setTimeout(() => {
        this.redirectUser();
      }, 3000);
    }
  }

  redirectUser() {
    window.location.assign(this.callbackUrl);
  }
}
